/**
 * How an agent is shown to people: "adversarial-review" -> "Adversarial Review".
 *
 * The stored name is a handle — it is what gets @mentioned, so it cannot hold
 * spaces — and a handle reads as a slug in a transcript. Derived rather than
 * stored so every agent, including ones users create, reads well without a
 * second field to keep in step.
 */
export function agentDisplayName(handle: string): string {
  const words = handle.split(/[-_\s]+/).filter(Boolean);
  if (words.length === 0) return handle;
  return words.map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
}
